import { render, staticRenderFns } from "./wikiPage.vue?vue&type=template&id=0f091e75&"
import script from "./wikiPage.vue?vue&type=script&lang=ts&"
export * from "./wikiPage.vue?vue&type=script&lang=ts&"
import style0 from "./wikiPage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports